import i from "./node.js";
import { v as r, h as d } from "../../../util-b2b0dc25.js";
import "../../../assets/utils/shared.js";
const h = (o, t) => o.reduce((e, s) => (s.isLeaf ? e.push(s) : (!t && e.push(s), e = e.concat(h(s.children, t))), e), []);
class u {
  constructor(t, e) {
    this.config = e, this.initNodes(t);
  }
  initNodes(t) {
    t = d(t), this.nodes = t.map((e) => new i(e, this.config)), this.flattedNodes = this.getFlattedNodes(!1, !1), this.leafNodes = this.getFlattedNodes(!0, !1);
  }
  appendNode(t, e) {
    const s = new i(t, this.config, e);
    (e ? e.children : this.nodes).push(s);
  }
  appendNodes(t, e) {
    t = d(t), t.forEach((s) => this.appendNode(s, e));
  }
  getNodes() {
    return this.nodes;
  }
  getFlattedNodes(t, e = !0) {
    const s = t ? this.leafNodes : this.flattedNodes;
    return e ? s : h(this.nodes, t);
  }
  getNodeByValue(t) {
    const e = this.getFlattedNodes(!1, !this.config.lazy).filter(
      (s) => r(s.path, t) || s.value === t
    );
    return e && e.length ? e[0] : null;
  }
}
export {
  u as default
};
